import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.ITEM_ATA.REALINHAMENTO.REALINHAR.INSERIR_REALINHAR_ATA]({ state }) {
		await api.realinhamento.inserirRealinhar(state)
	},
}
